import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import EmployeeContractsList from '../../../components/hr/contracts/general/list';
import EmployeePayslipsList from '../../../components/hr/payslips/general/list';
import PermissionsService from '../../../services/permissions';
import NoAccess from '../../../components/uiframeworks/noAccess';

interface HRPayslipsListPageProps {
}

const HRPayslipsListPage: React.FC<HRPayslipsListPageProps> = (props: HRPayslipsListPageProps) => {
    const {user, topbar} = useStore();
    const hasPermission = PermissionsService.hasPermission(['employees.payslips.read.all'], user.permissions);
    
    useEffect(() => {
        topbar.show('Employee Payslips', [
            {key: 'home', icon: faHome},
            {key: 'employees', text: 'Employees'},
            {key: 'payslips', text: 'Payslips'}
        ]);
    }, []);

    return <Stack>
        {hasPermission ? <EmployeePayslipsList /> : null}
        {!hasPermission ? <NoAccess /> : null}
    </Stack>;
};

export default HRPayslipsListPage;
